var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{staticClass:"notification-wrapper",attrs:{"width":_vm.width,"position":_vm.position},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var item = ref.item;
var closeHandler = ref.close;
return [_c('BaseNotification',{attrs:{"title":item.title,"text":item.text,"notification-type":item.type,"data-test-id":"notification"},on:{"close":closeHandler}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }